"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const translation_1 = require("../../common/js/helper/translation");
const product_1 = require("../helper/product");
const ProductCardTile_1 = __importDefault(require("./ProductCardTile"));
const ProductListItem_1 = __importDefault(require("./ProductListItem"));
const scrollPositions = new Map();
class ProductList extends react_1.default.Component {
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            sortedProducts: mobx_1.computed,
        });
    }
    componentDidMount() {
        this.restoreScroll();
    }
    componentDidUpdate() {
        this.restoreScroll();
    }
    get sortedProducts() {
        const { sortingProperty, products } = this.props;
        if (sortingProperty && undefined !== sortingProperty.sort) {
            return products.slice().sort(sortingProperty.sort);
        }
        return products;
    }
    render() {
        const { pathname } = this.props.location;
        const showPrice = this.props.forceHidePrice ? false : (0, product_1.showPrices)();
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-product-list d-flex align-items-sm-stretch', {
                'flex-column flex-sm-row flex-lg-column': !this.props.isCategorySoftware,
                'flex-wrap znd-product-list--cards': this.props.isCategorySoftware,
            }) },
            !this.props.isCategorySoftware ? (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-product-list__headline-price t-body-tiny d-none', {
                    'd-lg-block': showPrice,
                }) }, (0, translation_1.t)('product_list.headline.price'))) : null,
            this.sortedProducts.map((product) => this.renderProduct(product, pathname))));
    }
    renderProduct(product, pathname) {
        return this.props.isCategorySoftware ? (react_1.default.createElement("div", { key: product.id, className: "znd-product-card-wrapper" },
            react_1.default.createElement(ProductCardTile_1.default, { product: product, isCategorySoftware: this.props.isCategorySoftware, forceHidePrice: this.props.forceHidePrice, toSoftwareDetail: this.props.toSoftwareDetail }))) : (react_1.default.createElement(ProductListItem_1.default, { product: product, key: product.id, onClick: () => {
                scrollPositions.set(pathname, window.scrollY);
            } }));
    }
    restoreScroll() {
        const { pathname } = this.props.location;
        if (scrollPositions.has(pathname) && this.sortedProducts.length) {
            window.scrollTo(0, scrollPositions.get(pathname));
            scrollPositions.clear();
        }
        else if (this.sortedProducts.length) {
            scrollPositions.clear();
        }
    }
}
exports.default = (0, react_router_dom_1.withRouter)(ProductList);
